import React, { lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="relative bg-gradient-to-b from-gray-900 to-gray-950 text-white py-6 md:py-16 px-4" data-id="element-65">
      <div className="max-w-4xl mx-auto text-center" data-id="element-66">
        <h1 className="text-2xl md:text-6xl font-bold mb-2 md:mb-6" data-id="element-67">
          🚴 SISTEMA CICLISTA 360™
        </h1>

        <p className="text-sm md:text-2xl font-semibold mb-1 md:mb-4 text-gray-200" data-id="element-68">
          El sistema definitivo para el ciclista amateur argentino que quiere
          rendir más, sufrir menos y llegar entero al lunes.
        </p>

        <p className="text-xs md:text-lg text-gray-400 mb-3 md:mb-6" data-id="element-69">
          Para el ciclista apasionado de 35 a 55 años que sale los domingos, se
          parte el lomo y siente que el grupo siempre sabe algo que él no sabe.
        </p>

        <div className="mb-3 md:mb-8 flex justify-center" data-id="element-70">
          <img src="https://cdn.magicpatterns.com/uploads/a14RQjwYct5bRi8Hox77MR/98491a4f-3bc6-45a8-9fe3-3c4317df49af-removebg-preview.png" alt="Sistema Ciclista 360 - Producto Principal" className="w-48 md:w-auto md:max-w-md rounded-lg shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" loading="lazy" onClick={scrollToPurchase} data-id="element-71" />
        </div>

        <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-700 text-white font-bold text-sm md:text-lg px-6 md:px-8 py-3 md:py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse inline-flex items-center gap-2" data-id="element-72">
          ¡SÍ, QUIERO MEJORAR MI RENDIMIENTO HOY!{' '}
          <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-73" />
        </button>

        <div className="bg-gray-800 border border-gray-700 rounded-lg p-6 md:p-8 mt-8 md:mt-12 mb-0 text-left" data-id="element-74">
          <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center" data-id="element-75">
            ¿QUÉ ES EL SISTEMA CICLISTA 360?
          </h2>

          <p className="text-gray-300 mb-4 md:mb-6 text-sm md:text-base" data-id="element-76">
            Un sistema completo en PDF descargable que une por primera vez
            entrenamiento, nutrición, técnica, recuperación y mecánica en un
            solo lugar.
          </p>

          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6 text-sm md:text-base" data-id="element-77">
            <li className="flex items-start" data-id="element-78">
              <span className="text-green-500 mr-3" data-id="element-79">✅</span>
              <span data-id="element-80">5 Tomos con más de 400 páginas</span>
            </li>
            <li className="flex items-start" data-id="element-81">
              <span className="text-green-500 mr-3" data-id="element-82">✅</span>
              <span data-id="element-83">Adaptado 100% a Argentina</span>
            </li>
            <li className="flex items-start" data-id="element-84">
              <span className="text-green-500 mr-3" data-id="element-85">✅</span>
              <span data-id="element-86">Sin gimnasio caro ni suplementos importados</span>
            </li>
            <li className="flex items-start" data-id="element-87">
              <span className="text-green-500 mr-3" data-id="element-88">✅</span>
              <span data-id="element-89">Para el ciclista que sale los fines de semana</span>
            </li>
            <li className="flex items-start" data-id="element-90">
              <span className="text-green-500 mr-3" data-id="element-91">✅</span>
              <span data-id="element-92">5 Bonos incluidos hoy</span>
            </li>
            <li className="flex items-start" data-id="element-93">
              <span className="text-green-500 mr-3" data-id="element-94">✅</span>
              <span data-id="element-95">Acceso inmediato después del pago</span>
            </li>
          </ul>

          <p className="text-xl md:text-2xl font-bold text-center mb-0" data-id="element-96">
            💳 Desde $19.990 ARS
          </p>
        </div>
      </div>
    </section>;
}